import { render } from "./ClientPhonesList.vue?vue&type=template&id=69cc53fc"
import script from "./ClientPhonesList.vue?vue&type=script&lang=js"
export * from "./ClientPhonesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__